const pt = {
    '/': {
        title: '{brand} | Apostas Esportivas, Cassino ao Vivo & Saques Instantâneos',
        description: 'Caça-níqueis, cassino ao vivo & apostas esportivas no {brand}. Cassino crypto com saques instantâneos, jogos comprovadamente justos & suporte 24/7.'
    },
    '/casino': {
        title: 'Cassino Online | Caça-Níqueis, Blackjack & Dealers ao Vivo | {brand}',
        description: 'Caça-níqueis, blackjack, roleta & dealers ao vivo no {brand}. Centenas de jogos, depósitos crypto rápidos & saques instantâneos disponíveis 24/7.'
    },
    '/sports': {
        title: 'Apostas Esportivas Online | Apostas Crypto & Odds | {brand}',
        description: 'Aposte em esportes no {brand}. Odds competitivas em futebol, basquete & mais. Apostas ao vivo, apostas crypto seguras & pagamentos rápidos.'
    },
    '/livecasino': {
        title: 'Cassino ao Vivo | Blackjack, Roleta & Dealers ao Vivo | {brand}',
        description: 'Blackjack, roleta & jogos de cassino ao vivo no {brand}. Dealers reais, streaming em HD & ampla seleção de mesas ao vivo disponíveis 24/7.'
    },
    '/slots': {
        title: 'Caça-Níqueis Online | Grande Variedade de Slots de Cassino | {brand}',
        description: 'Uma enorme coleção de caça-níqueis no {brand}. Máquinas clássicas, vídeo slots & progressivas, todas jogáveis com crypto.'
    },
    '/vip': {
        title: 'Programa VIP | Recompensas Exclusivas & Benefícios | {brand}',
        description: 'O programa VIP do {brand}: recompensas exclusivas, bônus personalizados & suporte prioritário. Vantagens sob medida para jogadores fiéis.'
    },
    '/welcome-offer': {
        title: 'Oferta de Boas-Vindas | Cassino Crypto | {brand}',
        description: 'Reivindique o bônus de boas-vindas do {brand} no seu primeiro depósito. Saiba como começar e aproveite ao máximo nossa oferta de cadastro.'
    },
    '/referral': {
        title: 'Programa de Indicação | Convide Amigos & Ganhe Recompensas | {brand}',
        description: 'Indique amigos ao {brand} & ganhe recompensas quando eles se cadastrarem e jogarem. Compartilhe seu link e colete bônus por cada indicação.'
    },
    '/promotion-page': {
        title: 'Promoções do Cassino | Bônus & Ofertas Especiais | {brand}',
        description: 'Confira as últimas promoções do {brand}. Bônus atuais, torneios & eventos especiais – resgate sua oferta e comece a jogar.'
    },
    '/featurebuyin': {
        title: 'Slots com Feature Buy-In | Pule para os Rodadas Bônus | {brand}',
        description: 'Pule direto para as rodadas bônus com os slots de feature buy-in do {brand}. Ative recursos bônus instantaneamente para uma chance de grandes ganhos.'
    },
    '/gameshows': {
        title: 'Game Shows ao Vivo | Jogue Game Shows de Cassino no {brand}',
        description: 'Jogue game shows de cassino ao vivo no {brand}. Aproveite Crazy Time, Monopoly Live & mais, apresentados por dealers profissionais em tempo real.'
    },
    '/newgames': {
        title: 'Novos Jogos de Cassino | Últimos Slots & Jogos Ao Vivo | {brand}',
        description: 'Jogue os jogos de cassino mais recentes no {brand}. Atualizado regularmente com novos slots & jogos de mesa dos melhores provedores. Seja o primeiro a jogar.'
    },
    '/populargames': {
        title: 'Jogos de Cassino Populares | Top Slots & Jogos Ao Vivo | {brand}',
        description: 'Jogue os jogos de cassino mais populares no {brand}. Slots & jogos de mesa mais bem avaliados pela nossa comunidade, disponíveis com crypto.'
    },
    '/originals': {
        title: 'Jogos Originais de Cassino | Títulos Exclusivos | {brand}',
        description: 'Jogue jogos originais exclusivos no {brand}. Títulos únicos que você não encontrará em nenhum outro lugar, desenvolvidos internamente para uma experiência de cassino incomparável.'
    },
    '/providers': {
        title: 'Provedores de Jogos | Estúdios Parceiros & Software | {brand}',
        description: 'Explore todos os provedores de jogos no {brand}. Fazemos parceria com os melhores estúdios para oferecer uma biblioteca crypto diversificada e de alta qualidade.'
    },
    '/about-us': {
        title: 'Sobre Nós | Saiba Mais Sobre o {brand}',
        description: 'Conheça o {brand}, um cassino crypto & casa de apostas esportivas líder. Comprometidos com apostas seguras, justas & emocionantes com saques instantâneos em crypto.'
    },
    '/affiliate': {
        title: 'Programa de Afiliados | Ganhe Crypto com o {brand}',
        description: 'Faça parceria com o {brand} & ganhe comissões promovendo nosso cassino crypto. Taxas competitivas, rastreamento em tempo real & suporte dedicado para afiliados.'
    },
    '/faq': {
        title: 'FAQ | Perguntas Frequentes | {brand}',
        description: 'Encontre respostas para perguntas comuns sobre o {brand}. Consulte nosso FAQ para ajuda com contas, pagamentos, bônus & jogos de cassino.'
    },
    '/aml-policy': {
        title: 'Política AML | Prevenção à Lavagem de Dinheiro no {brand}',
        description: 'A política AML do {brand} garante um ambiente seguro e confiável. Leia sobre nossas medidas para prevenir atividades ilícitas em nossa plataforma.'
    },
    '/bonus-terms': {
        title: 'Termos e Condições dos Bônus | Promoções do {brand}',
        description: 'Leia as regras dos bônus & promoções do {brand}. Saiba como reivindicar, usar & sacar os ganhos de bônus da nossa plataforma.'
    },
    '/complaints-and-arbitration': {
        title: 'Reclamações e Arbitragem | Suporte ao Jogador no {brand}',
        description: 'Conheça o processo de reclamações & resolução de disputas do {brand}. Garantimos tratamento justo e resolvemos problemas de jogadores de forma rápida e transparente.'
    },
    '/fairness': {
        title: 'Jogos Comprovadamente Justos | Garantia de Justiça no {brand}',
        description: 'O {brand} usa tecnologia provably fair para garantir que cada resultado de jogo seja verificável, transparente & completamente aleatório.'
    },
    '/fairness-overview': {
        title: 'Visão Geral do Jogo Comprovadamente Justo | {brand}',
        description: 'O sistema provably fair do {brand} explicado. Princípios criptográficos que garantem a integridade do jogo & aleatoriedade completa em cada resultado.'
    },
    '/kyc-policy': {
        title: 'Política KYC | Conheça Seu Cliente no {brand}',
        description: 'A política KYC do {brand} descreve nosso processo de verificação de identidade. Saiba como protegemos os jogadores e mantemos um ambiente de jogo seguro.'
    },
    '/payment-policy': {
        title: 'Política de Pagamento | Depósitos & Saques em Crypto | {brand}',
        description: 'O {brand} aceita depósitos & saques em crypto. Leia nossa política de pagamento para limites de transação, moedas aceitas & prazos de processamento.'
    },
    '/privacy-policy': {
        title: 'Política de Privacidade | Proteção de Dados no {brand}',
        description: 'A política de privacidade do {brand}. Saiba como coletamos, usamos & protegemos seus dados pessoais em nossa plataforma de cassino crypto.'
    },
    '/responsible-gaming': {
        title: 'Jogo Responsável | Jogue com Segurança no {brand}',
        description: 'O {brand} está comprometido com o jogo responsável. Acesse ferramentas & recursos para gerenciar seus hábitos de jogo e jogar com segurança.'
    },
    '/terms-of-service': {
        title: 'Termos de Serviço | {brand}',
        description: 'Revise os termos & condições que regem seu uso do {brand}. Entenda seus direitos e responsabilidades como jogador.'
    },
    '/terms-sports': {
        title: 'Termos e Condições de Apostas Esportivas | {brand}',
        description: 'Os termos & condições de apostas esportivas do {brand}. Regras para fazer apostas, pagamentos de ganhos & uso da casa de apostas em nossa plataforma.'
    }
};
export default pt;
